import CopyButton from "@components/buttons/CopyButton";
import RedirectButton from "@components/buttons/RedirectButton";
import DataPill from "@components/pills/DataPill";
import { Transactions } from "@services/models/Transactions/TransactionByIdModel";
import { useEffect, useState } from "react";
import ConstantFunctions from "../../../utils/constants_functions";

const TransactionDetailContainer: React.FC<{
  transaction: Transactions;
  network: string;
  blockNumberFromSocket: number;
  index: number;
  ledger?: string;
  isPscreen?: boolean;
}> = ({
  transaction,
  network,
  blockNumberFromSocket,
  index,
  ledger,
  isPscreen = false,
}) => {
  const constantFunctions = new ConstantFunctions();
  const [confirmations, setConfirmations] = useState<number>(0);

  useEffect(() => {
    if (blockNumberFromSocket > 0) {
      let confirmationDifference =
        blockNumberFromSocket - transaction.blockNumber;
      if (confirmationDifference > 15) {
        setConfirmations(15);
      } else {
        setConfirmations(confirmationDifference);
      }
    }
  }, [blockNumberFromSocket]);

  return (
    <div
      className={`rounded-lg flex flex-col ${
        isPscreen ? "mb-2" : "my-2"
      } border border-border-subtle`}>
      <div className="flex flex-col rounded-lg p-[8px] bg-bg-trx-card-header rounded-t-lg rounded-b-none">
        <span className="text-[12px] font-semibold text-center">
          {`  Transaction details #${index + 1}`}
        </span>
      </div>
      <div className="flex flex-col bg-[#FFFFFF] p-[8px] rounded-t-none rounded-b-lg">
        <div className="flex flex-row justify-between">
          <span className="font-medium text-[12px] text-text-label">
            {ledger === "CR" ? "From address" : "To address"}
          </span>
          <CopyButton
            copyText={
              ledger === "CR" ? transaction.fromAddress : transaction.toAddress
            }
            copyMessage="Address copied to clipboard!"
            fillColor=""
          />
        </div>
        <span className="text-text-base font-medium text-[12px]">
          {ledger === "CR" ? transaction.fromAddress : transaction.toAddress}
        </span>
        <div className="flex flex-row justify-between w-full mt-[12px]">
          <span className="font-medium text-[12px] text-text-label">
            Transaction Hash
          </span>
          <div className="flex flex-row gap-[8px]">
            <RedirectButton
              transactionHash={transaction.transactionHash}
              network={network}
              fillColor=""
            />
            <CopyButton
              copyText={transaction.transactionHash}
              copyMessage="Transaction Hash copied to clipboard!"
              fillColor=""
            />
          </div>
        </div>
        <span className="text-text-base font-medium text-[12px] break-all mt-1">
          {transaction.transactionHash}
        </span>
        <div className=" p-[8px] mt-[12px] flex flex-row justify-between w-full border-t border-t-border-subtle">
          <div className="flex flex-col items-center">
            <span className="font-medium text-[12px] text-text-label">
              Amount
            </span>
            <span className="font-medium text-[12px] text-text-base">
              {constantFunctions.formatAmount(transaction.amount)}
            </span>
          </div>
          <div className="w-px bg-border-subtle" />
          <div className="flex flex-col items-center">
            <span className="font-medium text-[12px] text-text-label">
              Confirmations
            </span>
            <span className="font-medium text-[12px] text-text-base">
              {transaction.confirmationStatus === 1 ? (
                <>
                  {transaction.requiredConfirmations} {" / "}
                  {transaction.requiredConfirmations}
                </>
              ) : (
                <>
                  {confirmations} {" / "}
                  {transaction.requiredConfirmations}
                </>
              )}
            </span>
          </div>
          <div className="w-px bg-border-subtle" />
          <div className="flex flex-col">
            <span className="font-medium text-[12px] text-text-label text-right">
              Status
            </span>
            <DataPill
              value={
                transaction.confirmationStatus === 0 ? "pending" : "confirmed"
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetailContainer;
